module.exports = __webpack_public_path__ + "static/img/back-2-shcool.84204ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/back-2-shcool.png
// module id = ZfIV
// module chunks = 1